(function() {
  'use strict';

  var PLACEHOLDER_TEXT = 'Please select an option';
  var BUNDLE_CONTAINER_ID = 'simple-bundles-io-options';

  var addToCartButton = null;
  var isManualSubmit = false;
  var bundleReady = false; // Only manage button after bundle is fully loaded

  // ============================================
  // UTILITY FUNCTIONS
  // ============================================

  function getBundleContainer() {
    return document.getElementById(BUNDLE_CONTAINER_ID);
  }

  function getBundleSelects() {
    var container = getBundleContainer();
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('select'));
  }

  function getProductForm() {
    return document.querySelector('form.product-purchase-form') ||
           document.querySelector('form[data-product-id]');
  }

  function getAddToCartButton() {
    var form = getProductForm();
    if (!form) return null;
    return form.querySelector('button[data-add-to-cart-text]') ||
           form.querySelector('button[type="submit"]') ||
           form.querySelector('.button');
  }

  // Extract base product name from option text
  // Handles both "ProductName - VariantSize" and "VendorTitle inspired - ProductName"
  function getBaseProductName(optionText) {
    var parts = optionText.trim().split(' - ');

    if (parts.length === 2) {
      var firstPart = parts[0].trim();
      var secondPart = parts[1].trim();

      if (firstPart.toLowerCase().includes('inspired')) {
        return secondPart;
      } else {
        return firstPart;
      }
    }

    return optionText.trim();
  }

  // ============================================
  // PLACEHOLDER & SORTING
  // ============================================

  function transformAndSortOptions(select) {
    var options = Array.prototype.slice.call(select.options);

    var placeholderOption = options.find(function(opt) {
      return opt.disabled || opt.value === '' ||
             opt.text.trim().toLowerCase() === PLACEHOLDER_TEXT.toLowerCase();
    });

    var regularOptions = options.filter(function(opt) {
      return !(opt.disabled && opt.value === '') &&
             opt.text.trim().toLowerCase() !== PLACEHOLDER_TEXT.toLowerCase();
    });

    // Transform option text format
    regularOptions.forEach(function(option) {
      var optionText = option.text.trim();
      var parts = optionText.split(' - ');

      // Skip if already transformed
      if (optionText.toLowerCase().includes('inspired')) return;

      if (parts.length === 2) {
        var productName = parts[0].trim();
        var vendorTitle = window.bundleVendorLookup && window.bundleVendorLookup[productName];

        if (vendorTitle) {
          var cleanVendorTitle = vendorTitle.replace(/^Inspired By\s*/i, '');

          // Decode HTML entities
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = cleanVendorTitle;
          cleanVendorTitle = tempDiv.textContent || tempDiv.innerText || cleanVendorTitle;

          option.text = cleanVendorTitle + ' inspired - ' + productName;
        }
      }
    });

    // Sort options alphabetically
    regularOptions.sort(function(a, b) {
      var textA = a.text.trim().toLowerCase();
      var textB = b.text.trim().toLowerCase();
      return textA.localeCompare(textB);
    });

    // Rebuild select
    select.innerHTML = '';

    if (placeholderOption) {
      placeholderOption.disabled = false; // Enable so it can be selected
      placeholderOption.value = ''; // Ensure empty value
      select.appendChild(placeholderOption);
    }

    regularOptions.forEach(function(option) {
      select.appendChild(option);
    });

    // Always default to placeholder
    if (placeholderOption) {
      select.value = '';
    }
  }

  function setPlaceholderAsDefault(select) {
    if (select.dataset.bundleManagerProcessed === 'true') return;

    var options = Array.prototype.slice.call(select.options);
    var placeholderOption = options.find(function(opt) {
      return opt.text.trim().toLowerCase() === PLACEHOLDER_TEXT.toLowerCase();
    });

    if (placeholderOption) {
      placeholderOption.disabled = false;
      select.value = placeholderOption.value || '';
    }

    select.dataset.bundleManagerProcessed = 'true';

    // Trigger change event
    var evt = new Event('change', { bubbles: true });
    select.dispatchEvent(evt);
  }

  // ============================================
  // BUTTON STATE MANAGEMENT
  // ============================================

  function areAllOptionsSelected() {
    var selects = getBundleSelects();
    if (selects.length === 0) return true; // No bundle = allow normal operation

    return selects.every(function(select) {
      var selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) return false;

      var isPlaceholder = selectedOption.value === '' ||
                          selectedOption.text.trim().toLowerCase() === PLACEHOLDER_TEXT.toLowerCase();
      return !isPlaceholder;
    });
  }

  function getUpsellAddButton() {
    return document.querySelector('.lb-spc-details-btn');
  }

  function updateButtonState() {
    // Don't touch button until bundle is confirmed ready
    if (!bundleReady) return;

    if (!addToCartButton) {
      addToCartButton = getAddToCartButton();
    }

    var upsellButton = getUpsellAddButton();
    var allSelected = areAllOptionsSelected();

    // Update main Add to Cart button
    if (addToCartButton) {
      addToCartButton.disabled = !allSelected;
    }

    // Update upsell gift box Add button (if present)
    if (upsellButton) {
      // Add click blocker if not already added
      if (!upsellButton.dataset.bundleClickHandler) {
        upsellButton.dataset.bundleClickHandler = 'true';
        upsellButton.addEventListener('click', function(e) {
          if (!areAllOptionsSelected()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
      }

      if (allSelected) {
        upsellButton.style.pointerEvents = '';
        upsellButton.style.opacity = '';
        upsellButton.style.backgroundColor = '#000';
        upsellButton.style.color = '#fff';
      } else {
        upsellButton.style.pointerEvents = 'none';
        upsellButton.style.opacity = '0.5';
        upsellButton.style.backgroundColor = '';
        upsellButton.style.color = '';
      }
    }
  }

  // ============================================
  // DUPLICATE DETECTION
  // ============================================

  function getAllSelectedProducts() {
    var selects = getBundleSelects();
    var selectedProducts = [];

    selects.forEach(function(select) {
      var selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value && selectedOption.value !== '') {
        var baseProductName = getBaseProductName(selectedOption.text);
        selectedProducts.push(baseProductName);
      }
    });

    return selectedProducts;
  }

  function areAllSelectionsTheSame(selections) {
    if (selections.length <= 1) return false;

    var firstProduct = selections[0];
    return selections.every(function(product) {
      return product === firstProduct;
    });
  }

  function createDuplicateModal(productCount, productName) {
    // Remove any existing modal
    var existingModal = document.getElementById('bundle-duplicate-modal');
    if (existingModal) {
      existingModal.remove();
    }

    var modalHTML =
      '<div id="bundle-duplicate-modal" class="cc-popup cc-popup--visible" aria-hidden="false" data-freeze-scroll="true" style="display: flex !important; position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 9999 !important;">' +
        '<div class="cc-popup-background" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1;"></div>' +
        '<div class="cc-popup-modal" role="dialog" aria-modal="true" aria-labelledby="bundle-duplicate-title" style="position: relative; z-index: 2; margin: auto; background: white; padding: 20px; border-radius: 8px; max-width: 500px; width: 90%;">' +
          '<button type="button" class="cc-popup-close" aria-label="Close" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 24px; cursor: pointer;">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<line x1="18" y1="6" x2="6" y2="18"></line>' +
              '<line x1="6" y1="6" x2="18" y2="18"></line>' +
            '</svg>' +
          '</button>' +
          '<div class="cc-popup-container">' +
            '<div class="cc-popup-content">' +
              '<div class="cc-popup-text">' +
                '<h2 id="bundle-duplicate-title" style="margin-top: 0;">Same Product Selected</h2>' +
                '<p>You have selected ' + productCount + ' of the same product: <strong>' + productName + '</strong></p>' +
                '<p>Are you sure you want to continue?</p>' +
              '</div>' +
              '<div class="bundle-duplicate-actions" style="display: flex; gap: 10px; margin-top: 20px; flex-wrap: wrap;">' +
                '<button type="button" class="button button--large bundle-duplicate-cancel" style="flex: 1; min-width: 120px;">Cancel</button>' +
                '<button type="button" class="button button--large bundle-duplicate-proceed" style="flex: 1; min-width: 120px;">Add to Cart</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    var modal = document.getElementById('bundle-duplicate-modal');

    return new Promise(function(resolve) {
      var closeButton = modal.querySelector('.cc-popup-close');
      var background = modal.querySelector('.cc-popup-background');
      var cancelButton = modal.querySelector('.bundle-duplicate-cancel');
      var proceedButton = modal.querySelector('.bundle-duplicate-proceed');

      function closeModal(userConfirmed) {
        modal.remove();
        document.removeEventListener('keydown', handleKeyPress);
        resolve(userConfirmed);
      }

      function handleKeyPress(event) {
        if (event.key === 'Escape') {
          closeModal(false);
        }
      }

      closeButton.addEventListener('click', function() { closeModal(false); });
      background.addEventListener('click', function() { closeModal(false); });
      cancelButton.addEventListener('click', function() { closeModal(false); });
      proceedButton.addEventListener('click', function() { closeModal(true); });

      document.addEventListener('keydown', handleKeyPress);
      cancelButton.focus();
    });
  }

  // ============================================
  // FORM SUBMISSION HANDLING
  // ============================================

  function handleFormSubmit(event) {
    if (isManualSubmit) {
      isManualSubmit = false;
      return;
    }

    var selectedProducts = getAllSelectedProducts();

    if (selectedProducts.length > 1 && areAllSelectionsTheSame(selectedProducts)) {
      var productCount = selectedProducts.length;
      var productName = selectedProducts[0];

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      createDuplicateModal(productCount, productName).then(function(userConfirmed) {
        if (userConfirmed) {
          isManualSubmit = true;

          if (addToCartButton) {
            addToCartButton.click();
          } else {
            var form = getProductForm();
            if (form) form.submit();
          }
        }
      });

      return false;
    }
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function processSelect(select) {
    transformAndSortOptions(select);
    setPlaceholderAsDefault(select);

    // Add change listener for button state
    select.addEventListener('change', updateButtonState);
  }

  function processBundleContainer() {
    var container = getBundleContainer();
    if (!container) return false;

    var selects = getBundleSelects();
    if (selects.length === 0) return false;

    // Bundle is now ready - we can safely manage the button
    bundleReady = true;

    selects.forEach(processSelect);
    updateButtonState();

    return true;
  }

  function init() {
    // Try to process immediately
    var processed = processBundleContainer();

    // Set up form submission handler
    var form = getProductForm();
    if (form) {
      form.addEventListener('submit', handleFormSubmit, true);
    }

    // Watch for dynamically added bundle content and upsell buttons
    var observer = new MutationObserver(function(mutations) {
      var shouldProcess = false;
      var shouldUpdateButtons = false;

      mutations.forEach(function(mutation) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) return;

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          // Check if this is the bundle container or contains it
          if (node.id === BUNDLE_CONTAINER_ID ||
              (node.querySelector && node.querySelector('#' + BUNDLE_CONTAINER_ID))) {
            shouldProcess = true;
          }

          // Check if this is a select inside the bundle container
          if (node.tagName === 'SELECT') {
            var container = getBundleContainer();
            if (container && container.contains(node)) {
              processSelect(node);
              updateButtonState();
            }
          }

          // Check if upsell button was added
          if (node.classList && node.classList.contains('lb-spc-details-btn') ||
              (node.querySelector && node.querySelector('.lb-spc-details-btn'))) {
            shouldUpdateButtons = true;
          }
        });
      });

      if (shouldProcess) {
        processBundleContainer();
      }

      if (shouldUpdateButtons) {
        updateButtonState();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
